import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import "./Logout.css";
import { useNavigate } from "react-router-dom";
import { API } from "../backend";

const Logout = ({ setIsLogoutVisible, setToken }) => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const confirmLogout = (event) => {
    event.stopPropagation();
    setShowModal(true);
  };

  const handleProfileClick = () => {
    setIsLogoutVisible(false);
    navigate("/mycourse");
  };

  const handleLogoutClick = async () => {
    const token = Cookies.get("token"); // Get token from cookies
    if (!token) return; // If no token, do nothing

    try {
      await axios.post(
        `${API}api/v1/user/logout/`,
        {},
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      );

      Cookies.remove("token");
      setToken(null);
      document.dispatchEvent(new Event("tokenChange"));
      setShowModal(false);
      setIsLogoutVisible(false)
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

	return (
    <>
		<div className="popup-logout">
			<div className="profile-logout-div" onClick={handleProfileClick}>
				<p className="logout-title">پروفایل</p>
				<div className="logout-logo">

          <svg className="logout-svg" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="16" r="7" stroke="#E53B1F" stroke-width="2" stroke-linecap="round" />
            <path d="M9.69826 33.8959C10.9777 29.2068 15.8295 27 20.69 27H27.31C32.1705 27 37.0223 29.2068 38.3017 33.8959C38.5641 34.8574 38.7736 35.8979 38.8923 37.0031C39.0104 38.1013 38.1046 39 37 39H11C9.89543 39 8.98964 38.1013 9.10765 37.0031C9.2264 35.8979 9.43592 34.8574 9.69826 33.8959Z" stroke="#3CCFF1" stroke-width="2" stroke-linecap="round" />
          </svg>
				</div>
			</div>
			<div className="profile-logout-div" onClick={confirmLogout}>
				<p className="logout-title">خروج</p>
				<div className="logout-logo">
          <svg className="logout-svg" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M30.0272 6.3288L33.8758 5.68737C36.7466 5.2089 38.182 4.96966 39.3368 5.23358C41.2376 5.668 42.8088 6.999 43.5498 8.80255C44 9.89822 44 11.3534 44 14.2639V34.1319C44 36.6782 44 37.9513 43.6539 38.9257C42.9319 40.9579 41.1749 42.4464 39.0516 42.8244C38.0336 43.0056 36.7778 42.7963 34.2662 42.3777L34.2662 42.3777L30.0272 41.6712L30.0272 41.6712C25.2382 40.873 22.8438 40.474 21.4219 38.7955C20 37.117 20 34.6895 20 29.8345V18.1655C20 13.3105 20 10.883 21.4219 9.20451C22.8438 7.52604 25.2382 7.12696 30.0272 6.3288Z" fill="#3CCFF1" />
            <path d="M6 24L5.06296 23.2504L4.46325 24L5.06296 24.7496L6 24ZM24 25.2C24.6627 25.2 25.2 24.6627 25.2 24C25.2 23.3373 24.6627 22.8 24 22.8V25.2ZM13.063 13.2504L5.06296 23.2504L6.93704 24.7496L14.937 14.7496L13.063 13.2504ZM5.06296 24.7496L13.063 34.7496L14.937 33.2504L6.93704 23.2504L5.06296 24.7496ZM6 25.2H24V22.8H6V25.2Z" fill="#E53B1F" />
          </svg>
				</div>
			</div>
		</div>

    {showModal && (
        <div className="logout-overlay" onClick={() => setShowModal(false)}>
          <div className="logout-modal" onClick={(e) => e.stopPropagation()}>
            <svg className="logout-svg-modal" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M30.0272 6.3288L33.8758 5.68737C36.7466 5.2089 38.182 4.96966 39.3368 5.23358C41.2376 5.668 42.8088 6.999 43.5498 8.80255C44 9.89822 44 11.3534 44 14.2639V34.1319C44 36.6782 44 37.9513 43.6539 38.9257C42.9319 40.9579 41.1749 42.4464 39.0516 42.8244C38.0336 43.0056 36.7778 42.7963 34.2662 42.3777L34.2662 42.3777L30.0272 41.6712L30.0272 41.6712C25.2382 40.873 22.8438 40.474 21.4219 38.7955C20 37.117 20 34.6895 20 29.8345V18.1655C20 13.3105 20 10.883 21.4219 9.20451C22.8438 7.52604 25.2382 7.12696 30.0272 6.3288Z" fill="#3CCFF1" />
              <path d="M6 24L5.06296 23.2504L4.46325 24L5.06296 24.7496L6 24ZM24 25.2C24.6627 25.2 25.2 24.6627 25.2 24C25.2 23.3373 24.6627 22.8 24 22.8V25.2ZM13.063 13.2504L5.06296 23.2504L6.93704 24.7496L14.937 14.7496L13.063 13.2504ZM5.06296 24.7496L13.063 34.7496L14.937 33.2504L6.93704 23.2504L5.06296 24.7496ZM6 25.2H24V22.8H6V25.2Z" fill="#E53B1F" />
            </svg>
            <p className='modal-title'>آیا مطمئن هستید که می‌خواهید خارج شوید؟</p>
            <div className="logout-buttons">
              <button className="cancel-btn" onClick={() => setShowModal(false)}>خیر</button>
              <button className="confirm-btn" onClick={handleLogoutClick}>بله</button>
            </div>
          </div>
        </div>
    )}
    </>
	);
};

export default Logout;
